<template>
  <div class="rfp-rr-title-section-174-or rr-title-section" :class="{ 'rfp-rr-rating-rtl': rtl }">
    <h2
      class="rfp-rr-title-section-175-or float-left"
      :class="{ 'rfp-rr-rating-rtl-float-right': rtl }"
      v-text="title"
    ></h2>

    <button
      v-if="enabled"
      class="rfp-rr-title-section-176-or rfp-rr-button write-review-btn float-right"
      :class="{ 'rfp-rr-rating-rtl-float-left': rtl }"
      @click="setStatus"
      v-text="buttonText"
    ></button>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-ratings-title-section',
  props: {
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    productItemId: {
      type: String,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    rtl: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    setStatus() {
      eventBus.emit('WriteReviewTags', this.buttonText);

      const cookieId = 'reviewSubmit' + this.productItemId;
      const cookieValue = this.$cookies.get(cookieId);

      if (cookieValue === null) {
        return eventBus.emit('show-write-review');
      }

      if (cookieValue === 'success') {
        return eventBus.emit('review-already-submitted');
      }

      eventBus.emit('show-review-warning');
    },
  },
};
</script>
